// extracted by mini-css-extract-plugin
export default {"profileBanner":"profile_profileBanner__vRxbM"};